import { formatNumber } from '../EmployeeCard/EmployeeLeaveManagementV2/leaveFormatters';
import { LEAVE_BALANCE_UNIT } from '../EmployeeCard/EmployeeLeaveManagementV2/leaveBalanceUtils';

const DASH = '—';

export const formatHoursDaysRequested = (t, data) => {
  const { dayLengthMode, measuredInUnit, requestedDays, requestedHours, hoursResolvable } = data || {};
  if (!dayLengthMode) return DASH;

  const daysValue =
    requestedDays === null || requestedDays === undefined
      ? DASH
      : t('leaveRequest_daysValue', { value: formatNumber(requestedDays) });
  const hoursValue =
    !hoursResolvable || requestedHours === null || requestedHours === undefined
      ? DASH
      : t('leaveRequest_hoursValue', { value: formatNumber(requestedHours) });

  return measuredInUnit === LEAVE_BALANCE_UNIT.Hours ? `${hoursValue} / ${daysValue}` : `${daysValue} / ${hoursValue}`;
};
